import axios from 'axios'
import Qs from 'qs'
import { Message } from 'element-ui'
import router from '@/router/router.js'
import storage from '@/assets/js/storage'
import { configUrl } from '@/assets/js/httpRequest/reqUrlConfig'
import store from '@/store'

var instance = axios.create({
  url: '/',

  baseURL: configUrl.baseURL,

  transformRequest: [function (data) {
    // 对 data 进行任意转换处理
    return data;
  }],

  transformResponse: [function (data) {
    // 对 data 进行任意转换处理
    return data;
  }],

  // `headers` 是即将被发送的自定义请求头
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },

  params: {
  },

  // `paramsSerializer` 是一个负责 `params` 序列化的函数
  paramsSerializer: function (params) {
    return Qs.stringify(params, { arrayFormat: 'brackets' })
  },
  // 对 data 进行任意转换处理
  transformRequest: [function (data) {
    return Qs.stringify(data)
  }],
  // 超时设置
  timeout: 60000 * 5,

  responseType: 'json', // 默认的

  validateStatus: function (status) {
    return status >= 200 && status < 300; // 默认的
  },
})

/* 请求拦截器 */
instance.interceptors.request.use(function (config) {
  let user = storage.localGet('user');
  if (!location.href.includes('login')) {
    if (store.state.login.userinfo['user_id'] != user.user.user_id) {    //信息不一致，退出
      router.replace({
        path: '/login'
      })
      return config;
    }
  }
  if (user && user.token) {
    const token = user.token;
    config.headers.common['Authorization'] = 'Bearer ' + token;
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

/* 响应拦截器 */
instance.interceptors.response.use(function (response) {
  return response
}, function (error) {
  let messageError = '服务错误，请稍后再试！';
  if (error.message.includes('401')) { // 到登录页重新获取token
    messageError = '登录失效，请重新登录！';
    storage.localRemove('user');
    router.replace({
      path: '/login'
    })
  } else if (error.message.includes('501') && error.response.data.message.includes('The user name or password is incorrect')) {
    messageError = '用戶名或密码不正确';
  } else if (error.message.includes('timeout')) {
    messageError = '请求超时，请稍后再试！';
  } else if (error.message.includes('403')) {
    messageError = '无权限访问！';
  } else if (error.response.data.message) {
    messageError = error.response.data.message;
  }
  Message({
    showClose: true,
    message: messageError,
    type: 'error'
  });
  return Promise.reject(error)
})

export default instance
